let preloadText = () => {
    return `
        <div class="form-content">
            Загрузка ...
        </div>
    `;
};

export default preloadText;
